import { createAction } from '@reduxjs/toolkit';
import { INode } from '../../../general/model';

export const loadBreadcrumbsStarted = createAction<
  void,
  'creativeHub/breadcrumbs/LOAD_BREADCRUMBS_STARTED'
>('creativeHub/breadcrumbs/LOAD_BREADCRUMBS_STARTED');
export const loadBreadcrumbsSuccess = createAction<
  { nodes: INode[] },
  'creativeHub/breadcrumbs/LOAD_BREADCRUMBS_SUCCESS'
>('creativeHub/breadcrumbs/LOAD_BREADCRUMBS_SUCCESS');
export const loadBreadcrumbsError = createAction<
  { error: any },
  'creativeHub/breadcrumbs/LOAD_BREADCRUMBS_ERROR'
>('creativeHub/breadcrumbs/LOAD_BREADCRUMBS_ERROR');
